import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from 'react-oidc-context';
import { Config } from "../Config";

export function TimeoutProvider({ children }: { children: any }) {
  
  const auth = useAuth();
  const location = useLocation();
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    
    const handleWindowEvents = () => {
      clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        // Signout and redirect to signin screen when the timeout occurs
        if(auth.isAuthenticated)
        {
            auth.signoutRedirect();
        }
        
      }, Config.app.timeoutMS);
    };

    // listen for specific window events to ensure the user is still active
    window.addEventListener("mousemove", handleWindowEvents);
    window.addEventListener("keydown", handleWindowEvents);
    window.addEventListener("click", handleWindowEvents);
    window.addEventListener("scroll", handleWindowEvents);

    handleWindowEvents();

    // cleanup function
    return () => {
      window.removeEventListener("mousemove", handleWindowEvents);
      window.removeEventListener("keydown", handleWindowEvents);
      window.removeEventListener("click", handleWindowEvents);
      window.removeEventListener("scroll", handleWindowEvents);
    };
  }, [auth.isAuthenticated, location.pathname]);

  return children;
}